/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $username: String
    $newAtts: [UpdateUserInput]
    $a360id: String
  ) {
    updateUser(username: $username, newAtts: $newAtts, a360id: $a360id)
  }
`;
export const updateUserPhone = /* GraphQL */ `
  mutation UpdateUserPhone(
    $username: String
    $a360id: String
    $phone: PhoneInput
    $primary: Boolean
    $prev: String
    $primaryUpdate: Boolean
    $currType: String
    $newType: String
  ) {
    updateUserPhone(
      username: $username
      a360id: $a360id
      phone: $phone
      primary: $primary
      prev: $prev
      primaryUpdate: $primaryUpdate
      currType: $currType
      newType: $newType
    )
  }
`;
export const createUserLog = /* GraphQL */ `
  mutation CreateUserLog(
    $username: String
    $log: String
    $app: String
    $info: String
  ) {
    createUserLog(username: $username, log: $log, app: $app, info: $info)
  }
`;
export const disableUser = /* GraphQL */ `
  mutation DisableUser($username: String) {
    disableUser(username: $username)
  }
`;
export const enableUser = /* GraphQL */ `
  mutation EnableUser($username: String) {
    enableUser(username: $username)
  }
`;
export const resetPassword = /* GraphQL */ `
  mutation ResetPassword($username: String) {
    resetPassword(username: $username)
  }
`;
export const updateUserPassword = /* GraphQL */ `
  mutation UpdateUserPassword(
    $username: String
    $password: String
    $details: String
  ) {
    updateUserPassword(
      username: $username
      password: $password
      details: $details
    )
  }
`;
export const createSponsor = /* GraphQL */ `
  mutation CreateSponsor(
    $username: String
    $password: String
    $newAtts: [UpdateUserInput]
  ) {
    createSponsor(username: $username, password: $password, newAtts: $newAtts) {
      Username
      Attributes {
        Name
        Value
        __typename
      }
      __typename
    }
  }
`;
export const editUserGroup = /* GraphQL */ `
  mutation EditUserGroup(
    $username: String
    $addGroup: String
    $removeGroup: String
  ) {
    editUserGroup(
      username: $username
      addGroup: $addGroup
      removeGroup: $removeGroup
    )
  }
`;
export const bypassMFA = /* GraphQL */ `
  mutation BypassMFA($username: String, $bypass: String) {
    bypassMFA(username: $username, bypass: $bypass)
  }
`;
export const editConfig = /* GraphQL */ `
  mutation EditConfig($maintenance: Boolean, $message: String) {
    editConfig(maintenance: $maintenance, message: $message) {
      env
      maintenance
      message
      __typename
    }
  }
`;
export const editUserMFA = /* GraphQL */ `
  mutation EditUserMFA($username: String, $mfa: MFAOptions, $a360id: String) {
    editUserMFA(username: $username, mfa: $mfa, a360id: $a360id)
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $username: String
    $a360id: String
    $actionBy: String
    $orphaned: Boolean
  ) {
    deleteUser(
      username: $username
      a360id: $a360id
      actionBy: $actionBy
      orphaned: $orphaned
    )
  }
`;
export const deleteMalaUser = /* GraphQL */ `
  mutation DeleteMalaUser($username: String) {
    deleteMalaUser(username: $username)
  }
`;
export const createLog = /* GraphQL */ `
  mutation CreateLog($input: CreateLogInput!) {
    createLog(input: $input) {
      id
      createdAt
      app
      action
      actionBy
      actionOn
      currVal
      newVal
      ipAddress
      browserDetails
      userAgent
      a360id
      cif
      updatedAt
      __typename
    }
  }
`;
export const updateLog = /* GraphQL */ `
  mutation UpdateLog($input: UpdateLogInput!) {
    updateLog(input: $input) {
      id
      createdAt
      app
      action
      actionBy
      actionOn
      currVal
      newVal
      ipAddress
      browserDetails
      userAgent
      a360id
      cif
      updatedAt
      __typename
    }
  }
`;
export const deleteLog = /* GraphQL */ `
  mutation DeleteLog($input: DeleteLogInput!) {
    deleteLog(input: $input) {
      id
      createdAt
      app
      action
      actionBy
      actionOn
      currVal
      newVal
      ipAddress
      browserDetails
      userAgent
      a360id
      cif
      updatedAt
      __typename
    }
  }
`;
export const createIp = /* GraphQL */ `
  mutation CreateIp($input: CreateIpInput!) {
    createIp(input: $input) {
      address
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateIp = /* GraphQL */ `
  mutation UpdateIp($input: UpdateIpInput!) {
    updateIp(input: $input) {
      address
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteIp = /* GraphQL */ `
  mutation DeleteIp($input: DeleteIpInput!) {
    deleteIp(input: $input) {
      address
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRestricted = /* GraphQL */ `
  mutation CreateRestricted($input: CreateRestrictedInput!) {
    createRestricted(input: $input) {
      a360id
      attempts
      lastAttempt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRestricted = /* GraphQL */ `
  mutation UpdateRestricted($input: UpdateRestrictedInput!) {
    updateRestricted(input: $input) {
      a360id
      attempts
      lastAttempt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRestricted = /* GraphQL */ `
  mutation DeleteRestricted($input: DeleteRestrictedInput!) {
    deleteRestricted(input: $input) {
      a360id
      attempts
      lastAttempt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDocument = /* GraphQL */ `
  mutation CreateDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      id
      documentId
      name
      container
      lob
      filterType
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDocument = /* GraphQL */ `
  mutation UpdateDocument($input: UpdateDocumentInput!) {
    updateDocument(input: $input) {
      id
      documentId
      name
      container
      lob
      filterType
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDocument = /* GraphQL */ `
  mutation DeleteDocument($input: DeleteDocumentInput!) {
    deleteDocument(input: $input) {
      id
      documentId
      name
      container
      lob
      filterType
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
